import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarPlus, X } from "lucide-react";
import { format, parseISO, isBefore, startOfDay } from "date-fns";

export default function DueDatePicker({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  const overdue = value && isBefore(parseISO(value), startOfDay(new Date()));

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid={testid}
          className={`flex items-center gap-1.5 rounded-md border px-2 py-1 text-[11px] font-medium transition-colors ${
            value
              ? overdue
                ? "border-rose-500/40 bg-rose-500/10 text-rose-400"
                : "border-border bg-secondary/50 text-foreground hover:bg-secondary"
              : "border-dashed border-border text-muted-foreground hover:text-foreground"
          }`}
        >
          <CalendarPlus className="h-3.5 w-3.5" />
          {value ? format(parseISO(value), "MMM d") : "Due date"}
          {value && (
            <X
              className="h-3 w-3 opacity-60 hover:opacity-100"
              onClick={(e) => {
                e.stopPropagation();
                onChange("");
              }}
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
